import {
    FETCH_GROUPS_REQUEST,
    GET_GROUPS,
    GET_SINGLE_GROUP,
    GROUPS_ERROR,
    SET_CLICKED_GROUP,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const fetchGroupsRequest = () => {
        return {
            type: FETCH_GROUPS_REQUEST,
        };
    };
    const getGroups = (groups) => {
        return {
            type: GET_GROUPS,
            payload: groups,
        };
    };

    const getSingleGroup = (singleGroup) => {
        return {
            type: GET_SINGLE_GROUP,
            payload: singleGroup,
        };
    };

    const groupsError = (error) => {
        return {
            type: GROUPS_ERROR,
            payload: error,
        };
    };

    const setClickedGroup = (group) => {
        return {
            type: SET_CLICKED_GROUP,
            payload: group,
        };
    };

    const saveEditedGroupInfo = (editedGroupInfo) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `groups/` + editedGroupInfo.id,
                    editedGroupInfo
                );
                dispatch(getGroups(editedGroupInfo));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(groupsError(errorMsg));
            }
        };
    };

    const getAllGroups = () => async () => axiosCall.get('practices/groups');

    const fetchAllGroups = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchGroupsRequest);
                var response = await axiosCall.get(`groups/`);
                const groups = response.data;
                dispatch(getGroups(groups));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(groupsError(errorMsg));
            }
        };
    };

    const setGroupedPractices = (x, newGroup) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(`groups/` + x, {
                    practices: newGroup,
                });
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(groupsError(errorMsg));
            }
        };
    };

    return {
        fetchAllGroups,
        fetchGroupsRequest,
        getAllGroups,
        getGroups,
        getSingleGroup,
        groupsError,
        saveEditedGroupInfo,
        setClickedGroup,
        setGroupedPractices,
    };
};

export default initActions;
